import { graphql } from '../../gql/wrapper/gql'

export const getIndexablePages = graphql(`
  query getIndexablePages {
    allMkMarketingPage(where: { mk_seo: { noIndex: { neq: true } }, _: { is_draft: false } }) {
      _id
      mk_slug {
        current
      }
      _updatedAt
    }
  }
`)

export default getIndexablePages
